module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fst"
  }, [_c('em', [_vm._v("Praise for KAREN HAWKINS…")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("“Always funny and sexy, a Karen Hawkins book is a sure delight!”")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "fsc"
  }, [_vm._v("—Victoria Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Karen Hawkins writes fast, fun, and sexy stories that are a perfect read for a rainy day, a sunny day, or any day at all!”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—Christina Dodd")]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Karen Hawkins will make you laugh and touch your heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—Rachel Gibson")]), _vm._v(" "), _c('p', {
    staticClass: "fst"
  }, [_c('em', [_vm._v("… and her sparkling historical romances featuring the MacLeans")])]), _vm._v(" "), _c('p', {
    staticClass: "fst1"
  }, [_c('em', [_vm._v("THE LAIRD WHO LOVED ME")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Readers who met Caitlyn in "), _c('em', [_vm._v("Sleepless in Scotland")]), _vm._v(" will applaud her return.… The story is filled with biting repartee, humor, and sexual tension that will keep you turning the pages with glee.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")]), _vm._v(" (4½ stars, Top Pick)")]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Delightful in every way.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—Reader To Reader")]), _vm._v(" "), _c('p', {
    staticClass: "fst"
  }, [_c('em', [_vm._v("SLEEPLESS IN SCOTLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Amusing yet profound.… Readers will be sleepless in America due to a one-sitting enjoyable time.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—Harriet Klausner")]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Delightfully humorous, poignant, and highly satisfying novels: that’s what Hawkins always delivers.”")])]), _c('p', {
    staticClass: "fsc"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")]), _vm._v(" (4½ stars)")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "fst"
  }, [_c('em', [_vm._v("TO CATCH A HIGHLANDER")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Love and laughter, poignancy and emotional intensity, endearing characters, and a charming plot are the ingredients in Hawkins’s utterly delightful tale.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Karen Hawkins’s best book to date! Fast, sensual, and brilliant, it tantalizes and pleases all in the same breath.… This is romance at its best!”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—Romance and More")]), _vm._v(" "), _c('p', {
    staticClass: "fst"
  }, [_c('em', [_vm._v("TO SCOTLAND, WITH LOVE")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Hawkins bring another hardheaded MacLean brother and a sassy miss together in a sensual battle of the sexes. Her humor, intelligent characters, and story are simply delightful.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "fst"
  }, [_c('em', [_vm._v("HOW TO ABDUCT A HIGHLAND LORD")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Hawkins takes a fiery Scot lass and a wastrel lord and puts them together in a match made in, well, not heaven, but one that’s heated, exciting, and touching. Hawkins excels at taking tried-and-true plotlines and turning them into fresh, vibrant books.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—"), _c('em', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“In "), _c('em', [_vm._v("How to Abduct a Highland Lord,")]), _vm._v(" the characters are as wonderful as the story.… [It] is laced with passion and drama, and with its wonderfully romantic and thrilling ending, it’s a story you don’t want to miss!”")]), _vm._v(" "), _c('p', {
    staticClass: "fsc"
  }, [_vm._v("—Joyfully Reviewed")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d00a7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/001.vue
// module id = 63
// module chunks = 0